export interface AnalyticEvent extends Record<string, any> {
  event: string;
  category: string;
  action: string;
  label: string | number;
  productName?: string;
}

export interface CommerceEvent extends Record<string, any> {
  event: string;
  item_list_id?: string,
  item_list_name?: string,
  transaction_id?: string;
  coupon?: string,
  shipping?: number,
  ecommerce?: CommerceEventDetails
}

export interface CommerceEventDetails extends Record<string, any> {
  currencyCode?: 'GBP';
  value: number;
  items: any;   
}

export interface CommerceEventItem extends Record<string, any> {
  item_id: string,
  item_name: string,
  affiliation: string
}

export type BasketEventType = "error" | "warning" | "notification";
export type CheckoutStep =  | "basket" | "checkout" | "payment" | "ticket_listing";

export interface BasketEvent extends Record<string, any> {
  event?: string;
  message_type: BasketEventType;
  checkout_step: CheckoutStep;
  message_name: string;
  message_text?: string;
  field_name?: string;
}

export function trackCheckoutEvent(event: BasketEvent): void {
  const JC = window["JC"];
  
  event.event = event.event || "checkout_message";
  
  JC.analyticsController.track(event);
}

export function trackEvent(event: AnalyticEvent): void {
  const JC = window["JC"];
  JC.analyticsController.track(event);

  const appInsights = window["appInsights"];
  appInsights?.trackEvent(`${event.event}.${event.action}`, event);
}

export function trackEcommerceEvent(event: CommerceEvent) {
  //ensure currency
  event.ecommerce.currencyCode = 'GBP';  
  
  var eventKey = `event_${event.event}`;

  var hasRaised = window[eventKey] !== undefined;

  if(!hasRaised) {
    const JC = window["JC"];
    JC.analyticsController.trackEcommerce(event);
    window[eventKey] = 1;
    
    setTimeout(() => {
      window[eventKey] = undefined;
    }, 500);
  }

}